import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IntegrationModule} from "../../../../../model/integration-module";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {JsonEditorService} from "../../../../../services/json-editor.service";
import {CommonMessagesService} from "../../../../../services/common-messages.service";
import {PreviousRouteService} from "../../../../../services/previous-route.service";
import {noSpecialCharacters} from "../../../../../shared/custom-validators";
import {DefaultDecoder} from "../../../../../model/default-decoder";
import {DefaultEncoder} from "../../../../../model/default-encoder";
import {DefaultDecodersService} from "../../../../../services/default-decoders.service";
import {DefaultEncodersService} from "../../../../../services/default-encoders.service";

@Component({
  selector: 'app-default-devices-form-integration-modules',
  templateUrl: './default-devices-form-integration-modules.component.html',
  styleUrls: ['./default-devices-form-integration-modules.component.scss']
})
export class DefaultDevicesFormIntegrationModulesComponent implements OnInit {

  @Input() mode: 'create' | 'edit';

  @Input() integrationModules: IntegrationModule[];
  @Output() integrationModulesChange = new EventEmitter<IntegrationModule[]>();
  @Output() previousStep = new EventEmitter<void>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<string>();

  integrationModulesForm: FormGroup;
  rowsForm: FormArray;

  defaultDecoders: DefaultDecoder[];
  defaultEncoders: DefaultEncoder[];
  integrationCodes: string[] = [];

  constructor(
    private defaultDecodersService: DefaultDecodersService,
    private defaultEncodersService: DefaultEncodersService,
    public jsonEditorService: JsonEditorService,
    private commonMessagesService: CommonMessagesService,
    private formBuilder: FormBuilder,
    private previousService: PreviousRouteService
  ) {
    this.integrationCodes = [
      'IOTSENS',
      'LORA',
      'WMBUS',
      'UNE',
      'CONTAZARA',
      'SHERLOG'
    ];
  }

  ngOnInit(): void {
    this.loadAndCreateForm();
  }

  private loadAndCreateForm(): void {
    const promises = [
      this.defaultDecodersService.getDefaultDecoders().toPromise(),
      this.defaultEncodersService.getDefaultEncoders().toPromise()
    ];
    Promise.all(promises).then((values: any[]) => {
      this.defaultDecoders = values[0].defaultDecoders.sort((a, b) => a.name > b.name ? 1 : -1);
      this.defaultEncoders = values[1].defaultEncoders.sort((a, b) => a.name > b.name ? 1 : -1);
      this.createForm(this.integrationModules);
    })
  }

  private createForm(integrationModules: IntegrationModule[]): void {
    this.rowsForm = this.formBuilder.array(
      integrationModules.map(module => this.formGroupFromIntegrationModule(module))
    );
    this.integrationModulesForm = this.formBuilder.group({
      integrationModules: this.rowsForm
    });
  }

  addModule(): void {
    const newModule = this.formGroupFromIntegrationModule(new IntegrationModule());
    this.rowsForm.push(newModule);
  }

  onRowDelete(rowIndex: number): void {
    this.rowsForm.removeAt(rowIndex);
  }

  onPreviousStep(): void {
    const modules = this.integrationModulesForm.get('integrationModules').value;
    this.previousStep.emit();
    this.integrationModulesChange.emit(modules);
  }

  onNextStep(): void {
    if (this.integrationModulesForm.valid) {
      const modules = this.integrationModulesForm.get('integrationModules').value;
      this.nextStep.emit();
      this.integrationModulesChange.emit(modules);
    }
  }

  private formGroupFromIntegrationModule(module: IntegrationModule): FormGroup {
    return this.formBuilder.group({
      integrationIdentifier: [module.integrationIdentifier, [
        Validators.maxLength(255),
        Validators.required,
        noSpecialCharacters
      ]],
      integrationCode: [module.integrationCode, [
        Validators.maxLength(255),
        Validators.required,
        noSpecialCharacters
      ]],
      technicalDetails: [module.technicalDetails],
      additionalInfo: [module.additionalInfo],
      decoder: [module.decoder],
      encoder: [module.encoder]
    });
  }

  onCancel(): void {
    this.cancel.emit(this.previousService.getPreviousUrl());
  }

  confirmDelete(rowIndex: number): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.onRowDelete(rowIndex);
    });
  }

}
